import React, { useState, useContext } from 'react';
import { useMutation } from '@apollo/client';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { SEND_FBO_FUEL_STATEMENT } from './queries';
import { FileSpinner } from '../../../elements/Loading';
import moment from 'moment';
import styled from 'styled-components';
import {
  TitleContainer,
  Title,
  Container,
  Row,
  TableHeader,
  CellRow,
  TableCell
} from './elements';
import { AUTH_TOKEN } from '../../../constants';
import secrets from '../../../secrets';
import AuthContext from '../../../contexts/AuthContext';

const LinkContainer = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
`;

const Statements = (props) => {
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [clickedDate, setClickedDate] = useState('');
  const [fileLoading, setFileLoading] = useState(false);
  const [lifetimeFileLoading, setLifetimeFileLoading] = useState(false);
  const FileDownload = require('js-file-download');

  const { user, refetchData } = useContext(AuthContext);
  const { credentials, headers, ownerPortalUserId } = useContext(AuthContext);
  const owner = user.ownerPortalUsers.find(owner => (
    owner.id === ownerPortalUserId
  ));

  const today = moment();
  var count = 13;
  var dates = [];

  while(count > 0) {
    dates.push(
      moment(today)
      .subtract(count, 'months')
      .endOf('month')
      .format('YYYY-MM-DD')
    )
    count--;
  }

  const getStyle = (position) => {
    return position === 0 ? rowCellFirst : rowCellLast
  }

  const rowCellFirst = {
    borderRadius: '0px 0px 0px 6px'
  }

  const rowCellLast = {
    borderRadius: '0px 0px 6px 0px'
  }

  const handleClick = (date) => {
    setFileLoading(true);
    setClickedDate(date)
    const axios = require('axios');
    const FileDownload = require('js-file-download');
    axios({
      method: 'get',
      url: `${secrets.api.baseUri}/portal-send-fbo-statement`,
      responseType: 'blob',
      headers: headers,
      params: {
        'fboId': owner.ownerId,
        'date': date
      }
    })
    .then(res => {
      const date = moment(clickedDate).format('MM-YYYY');
      setFileLoading(false);
      FileDownload(
        res.data,
        `Fly Louie Monthly Report for ${owner.ownerName}, ${date}.pdf`
      );
    })
  }

  const handleLifetimeClick = (date) => {
    setLifetimeFileLoading(true);
    const axios = require('axios');
    const FileDownload = require('js-file-download');
    axios({
      method: 'post',
      url: `${secrets.api.baseUri}/portal-send-fbo-lifetime-statement`,
      responseType: 'blob',
      headers: headers,
      params: {
        'fbo_id': owner.ownerId
      }
    })
    .then(res => {
      const date = moment(new Date()).format('MM-YYYY');
      setLifetimeFileLoading(false);
      FileDownload(
        res.data,
        `Fly Louie Lifetime Report for ${owner.ownerName}, ${date}.xlsx`
      );
    })
  }

  return (
    <>
      <Helmet>
        <title>Statements</title>
      </Helmet>
      <Container>
        <TitleContainer>
          <Title>
            Statements
          </Title>
        </TitleContainer>
        <LinkContainer>
          <a href="#" onClick={() => handleLifetimeClick()}>
            Lifetime Statement
          </a>
          { lifetimeFileLoading &&
            <FileSpinner style={{marginLeft: '20px'}} />
          }
        </LinkContainer>
        <div className="row">
          <TableHeader className="col-12">
            {`${owner.ownerName} - Monthly Statements`}
          </TableHeader>
        </div>
        {
          dates.map((date) => {
            let lastDay = moment(dates[dates.length - 1]).add(14, 'days');
            if(moment(lastDay).diff(date, 'days') >= 14) {
              return (
                <CellRow className="row">
                  <TableCell className="col-4"
                      style={date === dates[dates.length - 1] ? getStyle(0) : null}
                  >
                    {moment(date).format('MM-DD-YYYY')}
                  </TableCell>
                  <TableCell  className="col-4"
                      style={date === dates[dates.length - 1 ] ? getStyle(1) : null}
                  >
                    {fileLoading && clickedDate === date ?
                      <FileSpinner key={`spinner-${date}`} /> :
                      <a href="#" key={`a-${date}`}
                        onClick={
                          () => {
                            setClickedDate(moment(date).format('MM-DD-YYYY'));
                            handleClick(date);
                          }
                        }
                      >
                        View PDF
                      </a>
                    }
                  </TableCell>
                </CellRow>
              )
            }
          })
        }
      </Container>
    </>
  )
}

export default Statements;
